export default __webpack_public_path__ + "static/cipd-d7605a14aa9fd00dedc71911f7bd0696.png";